import React from "react";

type FaqStatusBannerProps = {
  variant: "success" | "error";
  children: React.ReactNode;
};

export const FaqStatusBanner: React.FC<FaqStatusBannerProps> = ({
  variant,
  children,
}) => {
  if (variant === "success") {
    return (
      <div
        className="mb-6 rounded-[1.5rem] border-4 border-[#86EFAC] bg-[#F0FDF4] p-4 shadow-[0_6px_0_#22C55E]/40"
        role="status"
      >
        <p className="text-center text-sm font-extrabold text-[#166534]">
          {children}
        </p>
      </div>
    );
  }
  return (
    <div
      className="mb-6 rounded-[1.5rem] border-4 border-[#FECACA] bg-[#FEF2F2] p-4 shadow-[0_6px_0_#FCA5A5]"
      role="alert"
    >
      <p className="text-center text-sm font-extrabold text-[#B91C1C]">
        {children}
      </p>
    </div>
  );
};
